/** Рабочая зона для календарного дня в таблице, отчётах и правилах. */
export const APP_TIME_ZONE = 'Europe/Minsk';
